import { motion } from "framer-motion";
import { Reveal } from "@/components/Reveal";

const CONTACTS = [
  {
    label: "Hablamos",
    href: "mailto:mbarcosdearaujo@gmail.com",
    testId: "email-link",
  },
  {
    label: "LinkedIn ↗",
    href: "https://www.linkedin.com/in/mirianbarcosmb",
    testId: "linkedin-link",
    external: true,
  },
  {
    label: "Ver mi CV ↗",
    href: "/cv-mirian-barcos.pdf",
    testId: "cv-link-footer",
    external: true,
  },
];

export default function Closing() {
  return (
    <section
      data-testid="closing-section"
      className="bg-mirian-wine px-6 pb-14 pt-32 text-mirian-cream md:px-12 md:pt-44 lg:px-20"
    >
      <div className="mx-auto max-w-6xl">
        <Reveal>
          <h2
            data-testid="closing-cafe"
            className="font-serif text-5xl leading-[1.05] sm:text-6xl lg:text-8xl"
          >
            ¿Tomamos un café?
          </h2>
        </Reveal>
        <Reveal delay={0.25}>
          <p className="mt-10 max-w-xl text-base leading-relaxed text-mirian-cream/70 md:text-lg">
            Porque después de mirar un negocio desde fuera, lo interesante
            sería poder mirarlo desde dentro.
          </p>
        </Reveal>

        <Reveal delay={0.45}>
          <nav
            aria-label="Contacto"
            className="mt-16 flex flex-wrap gap-x-12 gap-y-5 text-sm uppercase tracking-[0.2em]"
          >
            {CONTACTS.map((c) => (
              <a
                key={c.testId}
                data-testid={c.testId}
                href={c.href}
                {...(c.external
                  ? { target: "_blank", rel: "noopener noreferrer" }
                  : {})}
                className="relative border-b border-mirian-cream/25 pb-1 text-mirian-cream/80 transition-colors duration-300 hover:border-mirian-cream hover:text-mirian-cream"
              >
                <span aria-hidden="true" className="absolute -inset-3" />
                {c.label}
              </a>
            ))}
          </nav>
        </Reveal>

        <div className="mt-28 border-t border-mirian-cream/15 pt-14 md:mt-36">
          <Reveal delay={0.15}>
            <p
              data-testid="signature"
              className="origin-left -rotate-2 font-serif text-5xl italic text-mirian-cream sm:text-6xl"
            >
              Mírian Barcos
            </p>
            <motion.svg
              viewBox="0 0 300 20"
              className="mt-1 w-56 -rotate-2 sm:w-64"
              aria-hidden="true"
            >
              <motion.path
                d="M6 14 C 80 4, 200 6, 294 10"
                fill="none"
                stroke="#F4F0E7"
                strokeOpacity="0.45"
                strokeWidth="2.5"
                strokeLinecap="round"
                initial={{ pathLength: 0 }}
                whileInView={{ pathLength: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.9, delay: 0.5, ease: "easeOut" }}
              />
            </motion.svg>
            <p className="mt-6 text-xs uppercase tracking-[0.22em] text-mirian-cream/50">
              Dirección de Marketing y Gestión Comercial · ESIC
            </p>
            <p className="mt-1 text-xs uppercase tracking-[0.22em] text-mirian-cream/50">
              San Javier, Murcia
            </p>
          </Reveal>
        </div>

        <footer className="mt-20 flex flex-wrap items-baseline justify-between gap-4 text-xs text-mirian-cream/35">
          <p>Mírian Barcos · 2026</p>
          <p className="italic">Hecha para Impacto Marketing.</p>
        </footer>
      </div>
    </section>
  );
}
